import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { BulkProposalCard } from './BulkProposalCard';

interface Props {
  proposalId: string;
  emails: string[];
  /** The org unit every invitee joins ("code — name"), when the proposal names one. */
  orgUnitLabel?: string | null;
  resolved?: string | undefined;
  onConfirm: (proposalId: string) => void;
  onCancel: (proposalId: string) => void;
}

/**
 * Confirmation card for a bulk invitation. Every address is listed in full — a typo here
 * sends an invitation to a stranger, so the user has to be able to read them all back.
 */
export function InviteUsersProposalCard({
  proposalId,
  emails,
  orgUnitLabel,
  resolved,
  onConfirm,
  onCancel
}: Props) {
  const t = useFeatureTranslation('aiChat');

  return (
    <BulkProposalCard
      title={t('proposals.invite-users.title')}
      description={t('proposals.invite-users.countDescription', { count: emails.length })}
      proposalId={proposalId}
      rows={emails}
      rowKey={email => email}
      primary={email => email}
      footer={
        orgUnitLabel ? (
          <p className='m-0 text-sm text-foreground-subtle'>
            {t('proposals.invite-users.orgUnit', { label: orgUnitLabel })}
          </p>
        ) : undefined
      }
      resolved={resolved}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
